import axios from 'axios';
import { API_URL, GYPSYBALL_PYTHON_API_URL, LOGINAPP_API_URL, GYPSYBALL_PYTHON_API_TOKEN } from 'configs';
import { constructFrom } from 'date-fns';
import { isEmpty } from 'lodash';
import { useDispatch } from 'react-redux';
import { trimAndLimit } from 'utils/general';
import { v4 as uuidv4 } from 'uuid';
export const WORKSPACE_API_EXPOSURE_REQUEST = 'WORKSPACE_API_EXPOSURE_REQUEST';
export const WORKSPACE_API_EXPOSURE_SUCCESS = 'WORKSPACE_API_EXPOSURE_SUCCESS';

export const WORKSPACE_API_EXPOSURE_VALIDATION_ERROR = 'WORKSPACE_API_EXPOSURE_VALIDATION_ERROR';
const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_WORKSPACE_API_EXPOSURE_FEILD_VALIDATION_ERROR = 'HIDE_WORKSPACE_API_EXPOSURE_FEILD_VALIDATION_ERROR';
export const REDIRECT_TO_WORKSPACE_API_EXPOSURE_LIST = 'REDIRECT_TO_WORKSPACE_API_EXPOSURE_LIST';

export const WORKSPACE_API_EXPOSURE_GET_SUCCESS = 'WORKSPACE_API_EXPOSURE_GET_SUCCESS';
export const WORKSPACE_API_EXPOSURE_DROPDOWN_LIST_SUCCESS = 'WORKSPACE_API_EXPOSURE_DROPDOWN_LIST_SUCCESS';
export const WORKSPACE_API_EXPOSURE_SERVER_SUCCESS = 'WORKSPACE_API_EXPOSURE_SERVER_SUCCESS';


const SHOW_LOADER = 'SHOW_LOADER';
const HIDE_LOADER = 'HIDE_LOADER';




const showCommonLoader = (label = '') => ({
  type: SHOW_LOADER,
  common_loder_label: label
});
const hideCommonLoader = () => ({
  type: HIDE_LOADER
});

const workspaceRequest = () => ({
  type: WORKSPACE_API_EXPOSURE_REQUEST
});

const getDesc = (val) => {
  let desc = trimAndLimit(val, 65355);
  return desc !== 'null' && desc !== null ? desc : '';
};


export const workspaceApiExposureServerListSuccess = () => ({
  type: WORKSPACE_API_EXPOSURE_SERVER_SUCCESS
});

const workspaceApiExposureListSuccess = workspaceApiExpoureList => ({
  type: WORKSPACE_API_EXPOSURE_SUCCESS,
  workspaceApiExpoureList: workspaceApiExpoureList
});


export const workspaceApiExposureFailure = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'general_error'
});

const validationError = notification => ({
  type: WORKSPACE_API_EXPOSURE_VALIDATION_ERROR,
  validation_error: notification
});
const tokenError = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'token_expire'
});





const workspaceApiExposureAddUpadteSuccess = (message, action, dispatch) => {
  dispatch(workspaceApiExposureSuccessNotification(message));
  dispatch(redirectToWorkspaceApiExposureList());
};

const chatAttachmentSuccess = (message, dispatch) => {
  dispatch(chatAttachmentSuccessNotification(message));

};



export const redirectToWorkspaceApiExposureList = () => ({
  type: REDIRECT_TO_WORKSPACE_API_EXPOSURE_LIST
});

const getWorkspaceSuccess = (response, action) => ({
  type: WORKSPACE_API_EXPOSURE_GET_SUCCESS,
  record: response,
  actionType: action
});

const chatAttachmentSuccessNotification = message => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: 'success'
});

const fileAttachmentSuccessNotification = message => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: 'success'
});

const workspaceApiExposureSuccessNotification = message => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: 'success'
});
const WorkspaceConfigurationSuccessNotification = message => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: 'success'
});

export const hideWorkspaceApiExposureValidationError = feild_key => ({
  type: HIDE_WORKSPACE_API_EXPOSURE_FEILD_VALIDATION_ERROR,
  feild_key: feild_key
});








export const workspaceApiExposureListFetch = (user_id) => {

  var token = localStorage.getItem('token');
  return dispatch => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + 'workspaceApiExposure', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer ' + token
      },

    }).then(
      response => {
        dispatch(hideCommonLoader());
        dispatch(workspaceApiExposureListSuccess(response.data));
      },
      error => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};



export const addWorkspaceApiExposure = (data) => {
  const token = localStorage.getItem('token');

  return async (dispatch) => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());

    try {
      // Step 1: prepare value-based payload for first API
      const workspaceValuePayload = {
        ...data,
        workspaces: data.workspaces.map(w => w.value), // only IDs for first call
      };

      // First API call
      const firstResponse = await axios(API_URL + 'workspaceApiExposure/create', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + token,
        },
        data: workspaceValuePayload,
      });

      // Step 2: prepare label-based payload for second API
      const apiKeyPayload = {
        name: data.name,
        limit: data.limit,
        workspaces: data.workspaces.map(w => w.label),
        description: data.description || '',
        expires_at: data.expires_at,
      };

      const secondResponse = await axios(GYPSYBALL_PYTHON_API_URL + 'external/api-keys', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
        },
        data: apiKeyPayload,
      });

      // Step 3: Save second API response
      await dispatch(saveWorkspaceApiExposureResponse({
        object_viewed_id: data.object_viewed_id,
        response: secondResponse.data
      }));

      dispatch(hideCommonLoader());
      workspaceApiExposureAddUpadteSuccess(
        'Workspace Added and API Key Created Successfully',
        'create',
        dispatch
      );
    } catch (error) {
      dispatch(hideCommonLoader());
      handleErrorResponse(error, dispatch);
    }
  };
};

// export const updateWorkspaceApiExposure = (data) => {
//   const token = localStorage.getItem('token');

//   return async (dispatch) => {
//     dispatch(workspaceRequest());
//     dispatch(showCommonLoader());

//     try {
//       // Step 1: prepare value-based payload for first API
//       const workspaceValuePayload = {
//         ...data,
//         workspaces: data.workspaces.map(w => w.value), // only IDs for first call
//       };

//       // First API call
//       const firstResponse =    await axios(API_URL + 'workspaceApiExposure/update/' + data.get('id'), {
//         method: 'POST',
//         headers: {
//           Accept: 'application/json',
//           Authorization: 'Bearer ' + token,
//         },
//         data: workspaceValuePayload,
//       });

//       // Step 2: prepare label-based payload for second API
//       const apiKeyPayload = {
//         name: data.name,
//         limit: data.limit,
//         workspaces: data.workspaces.map(w => w.label), 
//         description: data.description || '',
//         expires_at: data.expires_at, 
//       };

//       const secondResponse = await axios(GYPSYBALL_PYTHON_API_URL + 'external/api-keys', {
//         method: 'POST',
//         headers: {
//           Accept: 'application/json',
//           'Content-Type': 'application/json',
//           Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
//         },
//         data: apiKeyPayload,
//       });

//       // Step 3: Save second API response
//       await dispatch(saveWorkspaceApiExposureResponse({
//         object_viewed_id: data.object_viewed_id,
//         response: secondResponse.data
//       }));

//       dispatch(hideCommonLoader());
//       workspaceApiExposureAddUpadteSuccess(
//         'Workspace Added and API Key Created Successfully',
//         'create',
//         dispatch
//       );
//     } catch (error) {
//       dispatch(hideCommonLoader());
//       handleErrorResponse(error, dispatch);
//     }
//   };
// };


export const updateWorkspaceApiExposure = (data) => {
  const token = localStorage.getItem('token');


  return async (dispatch) => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());

    try {
      // Step 1: Prepare AI API payload (label-based)
      const aiPayload = {
        name: data.name,
        limit: data.limit,
        workspaces: data.workspaces.map(w => w.label),
        description: data.description || '',
        expires_at: data.expires_at,
        is_active: data.is_active || ''
      };

      // Step 1: Call AI API (key in URL)
      const aiResponse = await axios(GYPSYBALL_PYTHON_API_URL + 'external/api-keys/' + data.key, {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
        },
        data: aiPayload,
      });



      // Step 2: Dispatch saving the AI response along with ID
      const payloadToSave = {
        ...aiResponse.data,
      };

      const updateId = data.id;



      await dispatch(updateWorkspaceApiExposureResponse(updateId, payloadToSave));

      dispatch(hideCommonLoader());

      workspaceApiExposureAddUpadteSuccess(
        'Workspace API Exposure updated successfully.',
        'update',
        dispatch
      );
    } catch (error) {
      dispatch(hideCommonLoader());
      handleErrorResponse(error, dispatch);
    }
  };
};


export const saveWorkspaceApiExposureResponse = (data) => {
  const token = localStorage.getItem('token');
  return async (dispatch) => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());

    try {
      await axios(API_URL + 'workspaceApiExposure/saveApiExposure/', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + token,
        },
        data: data,
      });

      // workspaceApiExposureAddUpadteSuccess(
      //   'Workspace Updated Successfully',
      //   'update',
      //   dispatch
      // );
    } catch (error) {
      handleErrorResponse(error, dispatch);
    } finally {
      dispatch(hideCommonLoader());
    }
  };
};

export const updateWorkspaceApiExposureResponse = (updateId, payloadToSave) => {


  const token = localStorage.getItem('token');
  return async (dispatch) => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());

    try {
      await axios(API_URL + 'workspaceApiExposure/updateApiExposure/' + updateId, {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + token,
        },
        data: {
          id: updateId,             
          data: payloadToSave
        },
      });

      // workspaceApiExposureAddUpadteSuccess(
      //   'Workspace Updated Successfully',
      //   'update',
      //   dispatch
      // );
    } catch (error) {
      handleErrorResponse(error, dispatch);
    } finally {
      dispatch(hideCommonLoader());
    }
  };
};




export const getWorkspaceApiExposureById = (id, action) => {
  var token = localStorage.getItem('token');
  return dispatch => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + 'workspaceApiExposure/getById/' + id, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer ' + token
      }
    }).then(
      response => {
        dispatch(hideCommonLoader());
        dispatch(getWorkspaceSuccess(response.data, action));
      },
      error => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};


export const deleteWorkspaceApiExposure = (id, object_viewed_id, key) => {
  const token = localStorage.getItem("token");

  return async (dispatch) => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());

    try {
      // Step 1: Delete from your Laravel backend
      await axios(API_URL + "workspaceApiExposure/delete/" + id, {
        method: "DELETE",
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: 'Bearer ' + token
        },
        data: {
          object_viewed_id: object_viewed_id
        }
      });

     
      // Step 2: Delete from external Python AI API
      await axios(GYPSYBALL_PYTHON_API_URL + 'external/api-keys/' + key, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`
        }
      });

      dispatch(hideCommonLoader());
      dispatch(workspaceApiExposureSuccessNotification('Workspace API Key deleted successfully'));
    } catch (error) {
      dispatch(hideCommonLoader());
      handleErrorResponse(error, dispatch);
    }
  };
};




// handling error reponse
const handleErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422 && error.response.data.error) {

      dispatch(validationError(error.response.data.error));
    } else if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()));
    } else {
      let err = '';
      if (error.response.data.error) {
        err = error.response.data.error.toString();
      } else {
        err = error.response.status + ` ` + error.response.statusText;
      }
      dispatch(workspaceApiExposureFailure(err));
    }
  } catch (e) {
    dispatch(workspaceApiExposureFailure('Unable to perform action.Something went wrong'));
  }
};





























